module.exports = __webpack_public_path__ + "img/iripple-helpdesk-dark.670737b9.png";